import {  Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import fetchfromAPI from "../utils/fetchfromAPI"

import Video from './Feed/Video'

const SearchDetail = () => {
  const [videos, setVideos] = useState([])
  const { searchTerm } =useParams()
  useEffect(() => {
    fetchfromAPI(`search?part=snippet&q=${searchTerm}`).then((data) => setVideos(data.items))

  }, [searchTerm])
  return (
    <div>
        <Box sx={{}} className="overflow-y-auto px-3 h-[90vh]">
          <Typography className='px-4' variant='h4' fontWeight="bold" mb={2} sx={{}}>
          Searched Result for : <span className=' ml-3 text-[#F31503]' >{searchTerm}</span>
          </Typography>
          <Video videos={videos} setVideos={setVideos} />
        </Box>
    </div>
  )
}

export default SearchDetail
